// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-card_default__2waoq","checkmark":"idt-card_checkmark__3kvzz","active":"idt-card_active__1bcz3","icon":"idt-card_icon__rxjac","title":"idt-card_title__2ty-h"};